// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"88b7b595","455":"ae1c548d","977":"23e3f9bb"}[chunkId] + ".chunk.js";
};